import { cycleCountPlanIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

/**
 * Records a physically counted bin. On a bin plan, stock missing from `counts`
 * is counted as 0, so the row always finishes; a product plan records `counts`.
 */
export const confirmCycleCountBin = unaryRpc({
  name: "confirmCycleCountBin" as const,
  input: z.object({
    planId: cycleCountPlanIdFormat.schema,
    storageLocationId: storageLocationIdFormat.schema,
    counts: z
      .array(
        z.object({
          productId: productIdFormat.schema,
          finalCount: z.int().min(0),
        }),
      )
      .max(500),
  }),
  output: z.object({}),
});
